import { CONTENT_LOADING, OPEN_SIDE_MENU, SET_SIDE } from "../actions/sideMenuActions";
import { RESET_FOR_MODEL_SELECTOR } from "../actions/sessionActions";
import SideMenuState from "../stateTypes/sideMenuState";
import { Side } from "../../components/SideMenu/side";

const initialState: SideMenuState = {
    sideMenuOpen: false,
    contentLoading: false,
    side: Side.Right,
};

const sideMenuReducer = (state: SideMenuState = initialState, action: any = {}) => {
    switch (action.type) {
        case OPEN_SIDE_MENU:
            return {
                ...state,
                sideMenuOpen: action.sideMenuOpen,
            };
        case SET_SIDE: {
            return {
                ...state,
                side: action.side,
            };
        }
        case CONTENT_LOADING: {
            return {
                ...state,
                contentLoading: action.contentLoading,
            };
        }
        case RESET_FOR_MODEL_SELECTOR:
            return initialState;
        default:
            return state;
    }
};

export default sideMenuReducer;
